import { Injectable, NgZone } from '@angular/core';

/** Resolves block UI across lazy-loaded chunks (student app only). */
export const STUDENT_BLOCK_UI_REGISTRY_KEY = '__studentBlockUiBox';

@Injectable({ providedIn: 'root' })
export class StudentBlockUIService {
  messageBox: any;

  constructor(private ngZone: NgZone) {}

  private resolveBox(): any {
    if (this.messageBox != null) {
      return this.messageBox;
    }
    return (window as any)[STUDENT_BLOCK_UI_REGISTRY_KEY] ?? null;
  }

  private publishBox(box: any): void {
    if (box == null) {
      return;
    }
    this.messageBox = box;
    (window as any)[STUDENT_BLOCK_UI_REGISTRY_KEY] = box;
  }

  private runBoxAction(action: (box: any) => void): void {
    const box = this.resolveBox();
    if (box == null) {
      return;
    }
    this.ngZone.run(() => {
      action(box);
    });
  }

  show(bool?: boolean): void {
    this.runBoxAction((box) => box.open(bool));
  }

  hide(): void {
    this.runBoxAction((box) => box.close());
  }

  showWithTimeout(callback: any, owner: any): void {
    this.runBoxAction((box) => box.openWithTimeout(callback, owner));
  }

  showWithTimeoutWithTime(callback: any, owner: any, time: number): void {
    this.runBoxAction((box) => box.openWithTimeoutWithTime(callback, owner, time));
  }

  setBox(box: any): void {
    this.publishBox(box);
  }

  clearBox(box: any): void {
    if (this.messageBox === box) {
      this.messageBox = null;
    }
    const win = window as any;
    if (win[STUDENT_BLOCK_UI_REGISTRY_KEY] === box) {
      delete win[STUDENT_BLOCK_UI_REGISTRY_KEY];
    }
  }

  getBox(): any {
    return this.resolveBox();
  }
}
